import { Container, Row, Col, Form, Button } from "react-bootstrap";
import emailjs from "emailjs-com";
import { useRef } from "react";
function GetInTouch() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wqxvvyb", // ✅ Your Service ID
        "template_qkofn8e", // ✅ Your Template ID
        form.current,
        "vwNB5WM_83ykdcls0", // ✅ Your Public Key
      )
      .then(
        () => {
          alert("✅ Thank you! Your form has been submitted.");
          form.current.reset();
        },
        (error) => {
          alert("❌ Something went wrong. Please try again.");
          console.error(error.text);
        },
      );
  };
  return (
    <>
      <Container fluid className="contact pt-5 pb-5 mb-10">
        <Row className="g-0 px-5">
          <Col
            lg={6}
            md={12}
            className="d-flex justify-content-center align-items-center py-5"
          >
            <img src="./getintouch.jpeg" alt="" className="about-img" />
          </Col>
          <Col lg={6} md={12} className="">
            <span className="fw-bold">Get In Touch!</span>
            <br />
            <br />
            <p>
              To work together please feel free to reach out to me using the
              contact form below. I will get back to you personally within 48
              work hours or as soon as possible!
            </p>
            <Form className="contaxt-form" ref={form} onSubmit={sendEmail}>
              {/* Name */}
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  required
                  name="name"
                  id="name"
                />
              </Form.Group>

              {/* Email */}
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  required
                  name="email"
                  id="email"
                />
              </Form.Group>

              {/* Phone */}
              <Form.Group className="mb-3">
                <Form.Label>Phone Number (WhatsApp)</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter your WhatsApp number"
                  name="mobile"
                  id="mobile"
                />
              </Form.Group>
              {/* Messages */}
              <Form.Group className="mb-3">
                <Form.Label>How can I help?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="How can I help"
                  name="message"
                  id="message"
                />
              </Form.Group>

              {/* Submit */}
              <div className="text-center">
                <Button type="submit" className="btn-primary">
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default GetInTouch;
